import { RemixBrowser } from '@remix-run/react'
import posthog from 'posthog-js'
import { startTransition, StrictMode, useEffect } from 'react'
import { hydrateRoot } from 'react-dom/client'

import { worker } from '../mocks/browser'

import { initSentryBrowser } from './utils/sentry.util'

declare global {
  interface Window {
    dataLayer: any[]

    env?: {
      STAGE: string
      POSTHOG_CLIENT_KEY?: string
      USER_IDENTITY_ID?: string
    }
  }
}

function PosthogInit() {
  useEffect(() => {
    if (window.env?.POSTHOG_CLIENT_KEY) {
      posthog.init(window.env.POSTHOG_CLIENT_KEY, {
        api_host: 'https://us.posthog.com',
        capture_pageview: false,
        capture_pageleave: false,
        bootstrap: {
          isIdentifiedID: false,
          distinctID: window.env?.USER_IDENTITY_ID,
        },
      })

      document.onvisibilitychange = () => {
        if (document.visibilityState === 'hidden') {
          posthog.capture('$pageleave')
        }
      }
    }
  }, [])

  return null
}

const bootstrap = async () => {
  if (window.ENABLE_MOCKED_SERVICE_WORKER) {
    await worker.start({
      onUnhandledRequest: 'bypass',
    })
  }

  if (process.env.NODE_ENV === 'production' && window.SENTRY_DSN) {
    initSentryBrowser({
      dsn: window.SENTRY_DSN || 'dev',
      environment: window.STAGE || 'dev',
      release: `v${window.APP_VERSION || '0.0.0'}`,
    })
  }

  startTransition(() => {
    hydrateRoot(
      document,
      <StrictMode>
        <PosthogInit />
        <RemixBrowser />
      </StrictMode>,
    )
  })
}

bootstrap()
